import React, { useMemo } from 'react';
import { styled } from '@linaria/react';
import { toggle } from 'opticks';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Icon } from '@daedalus/atlas/Icon';
import { Image, SizeType } from '@daedalus/atlas/Image';
import { Text } from '@daedalus/atlas/Text';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { ImageProvider } from '@daedalus/core/src/staticContent/types/ImageProvider';
import { ProgressiveImageCarousel } from './ProgressiveImageCarousel';
const _exp = /*#__PURE__*/() => Flex.Column;
const HeroImageContainer = /*#__PURE__*/styled(_exp())({
  name: "HeroImageContainer",
  class: "hh8udof",
  propsAsIs: true
});
const _exp2 = /*#__PURE__*/() => Flex.Column;
const CardGalleryContainer = /*#__PURE__*/styled(_exp2())({
  name: "CardGalleryContainer",
  class: "c1qjl395",
  propsAsIs: true
});
const ImageDisplayContainer = /*#__PURE__*/styled('div')({
  name: "ImageDisplayContainer",
  class: "i1kv16w0",
  propsAsIs: false
});
const _exp4 = /*#__PURE__*/() => Flex.Row;
const ImageCount = /*#__PURE__*/styled(_exp4())({
  name: "ImageCount",
  class: "i19gfopo",
  propsAsIs: true
});
interface CardGalleryProps {
  /** Imaging service for resizing */
  imageProvider: ImageProvider;

  /** List of images to be displayed */
  images: string[];

  /** URL of image to be displayed when images error or less then 4 */
  placeHolderImage?: string;

  /** Size of the main image. Options defined by the Image component */
  mainImageSize: SizeType;

  /** Whether the card is the priority card (card in the first position of the list) */
  isPriorityCard?: boolean;
}

/**
 * CardGallery is a selection of thumbnails and larger images for display on the hotel card
 *
 * This component requires a parent with a set height to work correctly as the main image is responsive
 * and is designed to grow with the height of the parent container.
 */
export const CardGallery: React.FC<CardGalleryProps> = ({
  images,
  imageProvider,
  mainImageSize,
  placeHolderImage = null,
  isPriorityCard = false
}) => {
  const {
    brandMainHotelImageIndex
  } = useBrand();
  const {
    image,
    totalImagesCount
  } = useMemo(() => ({
    image: images?.[brandMainHotelImageIndex || 0] ?? placeHolderImage,
    totalImagesCount: images?.length ?? 0
  }), [images, brandMainHotelImageIndex, placeHolderImage]);
  return toggle('fbdb929e-image-carousel-desktop-cards', <CardGalleryContainer>
      <HeroImageContainer justifyContent="center">
        <ImageDisplayContainer data-id="HeroImage">
          <Image hasSkeletonLoader url={image} placeHolderImage={placeHolderImage} size={mainImageSize} imageProvider={imageProvider} isResponsive />
          <ImageCount data-id="HeroImageCount" gap="s200" alignItems="center">
            <Icon name="Photo" size="sm" colorPath="content.neutral.c000" />
            <Text variant="labelXS" colorPath="content.neutral.c000">
              {totalImagesCount}
            </Text>
          </ImageCount>
        </ImageDisplayContainer>
      </HeroImageContainer>
    </CardGalleryContainer>, <CardGalleryContainer data-id="HeroImage">
      <ProgressiveImageCarousel images={images} imageProvider={imageProvider} isPriorityCard={isPriorityCard} />
    </CardGalleryContainer>);
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");